module.exports = __webpack_public_path__ + "media/images/sales/early/icon-apply-02-9fe6c4b85ed186889055792c261907fc.svg";